<template>
  <div :class="{ 'heading-success': (type === 'success'), 'heading-failure': (type === 'failure') }">
    <IconSuccess v-if="type === 'success'" />
    <IconFailure v-if="type === 'failure'" />
    <h2><slot /></h2>
  </div>
</template>

<script>
import IconSuccess from '@/components/icons/IconSuccess.vue'
import IconFailure from '@/components/icons/IconFailure.vue'

export default {
  name: 'Heading',
  components: {
    IconSuccess,
    IconFailure
  },
  props: {
    type: String
  }
}
</script>

<style>
.heading-success, .heading-failure {
  display: flex;
  margin: 24px 0 16px 0;
  align-items: center;
}
.heading-success h2, .heading-failure h2 {
  margin: 0 0 0 16px;
}
.heading-success {
  color: #00bd8e;
}
.heading-failure {
  color: rgb(190, 0, 48);
}
</style>
